<mat-form-field>
	<label [for]="elementId">{{label}}</label>
	<mat-select
		[id]="elementId"
		[formControl]="multiSelectCtrl"
		[multiple]="true" #multiSelect
		placeholder="Select"
		floatPlaceholder="never"
		[compareWith]="compareObjects"
		disableRipple="true" panelClass="form-create-container">
		<mat-select-trigger>
			{{ multiSelectCtrl?.value ? multiSelectCtrl?.value[0]?.label : '' }}
			<span class="multiple-additional-selection" *ngIf="multiSelectCtrl?.value?.length > 1">
				(+{{ multiSelectCtrl?.value?.length - 1 }}
				{{ multiSelectCtrl?.value?.length === 2 ? 'other' : 'others' }})
			</span>
		</mat-select-trigger>
		<mat-option *ngIf="data?.isSearch">
			<ngx-mat-select-search
				[placeholderLabel]="placeHolderLabel"
				[noEntriesFoundLabel]="noEntriesFoundLabel"
				[showToggleAllCheckbox]="selectAll"
				[toggleAllCheckboxIndeterminate]="isIndeterminate"
				[toggleAllCheckboxChecked]="isChecked"
				(toggleAll)="toggleSelectAll($event)"
				[formControl]="filterInputCtrl">
			</ngx-mat-select-search>
		</mat-option>
		<div class="options-height">
		<mat-option
			*ngFor="let option of filteredMultiList | async"
			[value]="option">
			{{ option[key] }}
		</mat-option>
	</div>
	</mat-select>
</mat-form-field>


